import { useRouter } from 'next/router'
import React from 'react'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useAppDispatch } from 'src/store/store'
import MobileViewSubCategory from './MobileMenSubCategory'
import MenCategorySlider from '../../../MenCategorySlider'

interface MenCategorySelectSectionProps {
  colletionData: any
  fetchUpdatedProduct: any
  setPage: any
  page: number
  dataLimite: number
  subCategoryRoute: string
  category?: string
  subCategory?: string
  childSubCategory?: string | string[]
}
export default function MenCategorySelectSection({ colletionData, fetchUpdatedProduct, setPage, page, dataLimite, subCategoryRoute, category, subCategory, childSubCategory }: MenCategorySelectSectionProps) {
  const dispatch = useAppDispatch()
  const router = useRouter()
  let filterData = colletionData?.find((cat) => cat?.slug === router?.query?.id)

  return (
    <React.Fragment>
      <div className="men-category-by-shoes-section">
        <div className="container">
          <div className="row section_3_row">
            <div className="left_block">
              <div
                className="left_cover"
                onClick={() => {
                  router.push('/fashion/men/', undefined, { scroll: false })
                  dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
                }}
              >
                <img src="/assets/icon/whiteLeftArrow.svg" alt="left-arrow" />
              </div>
            </div>
            <div className="right_block">
              <div className="right_block_cover">
                <MenCategorySlider colletionData={colletionData} subCategoryRoute={subCategoryRoute} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {subCategoryRoute === 'men' && <>
        <section className="men-category-by-shoes-banner-details-section">
          <div className="category-img-alignment">
            <img src={filterData?.banner_media} alt="" />
          </div>
          <div className="container">
            <div className="category-by-shoes-banner-section">
              <div className="category-by-shoes-heading-alignment">
                <h4>{filterData?.name}</h4>
                <p>{filterData?.description}</p>
              </div>
            </div>
          </div>
        </section>
      </>}
      {router?.query?.id !== 'accessories' && <MobileViewSubCategory fetchUpdatedProduct={fetchUpdatedProduct} setPage={setPage} page={page} dataLimite={dataLimite} category={category} subCategory={subCategory} childSubCategory={childSubCategory} />}
    </React.Fragment>
  )
}
